import { useState } from 'react';

import { SwipeableViews } from '@cast/design-system';

import { isE2E } from '@cast/utils';

import { WhatHappensNextStepDialogContent } from './_components/WhatHappensNextStepDialogContent';
import {
  InstallKentScriptStepDialogContent,
  InstallKentScriptStepDialogContentProps,
} from './InstallKentScriptStepDialogContent';

export type InstallKentScriptDialogContentProps = Omit<
  InstallKentScriptStepDialogContentProps,
  'onRunTheScript'
>;

type Slides = 'installKentScript' | 'whatHappensNext';

export const InstallKentScriptDialogContent = ({
  cluster,
  featureBeingInstalled,
  onClose,
  onBack,
  onCancel,
}: InstallKentScriptDialogContentProps) => {
  const [activeSlide, setActiveSlide] = useState<Slides>('installKentScript');

  return (
    <SwipeableViews
      slides={{
        installKentScript: (
          <InstallKentScriptStepDialogContent
            cluster={cluster}
            featureBeingInstalled={featureBeingInstalled}
            onClose={onClose}
            onBack={onBack}
            onRunTheScript={() => {
              setActiveSlide('whatHappensNext');
            }}
            onCancel={onCancel}
          />
        ),
        whatHappensNext: (
          <WhatHappensNextStepDialogContent
            onClose={onClose}
            onBack={() => setActiveSlide('installKentScript')}
          />
        ),
      }}
      activeSlide={activeSlide}
      disableAnimations={isE2E()}
    />
  );
};
